export class TingYun {
    window: any = window;
    // private event: any;
    private routerObj: object = {
        add: {
            name: '地址管理',
            key: 'aa0c2f78-4e2a-45e5-b73c-7c0793b1240d'
        },
        editAdd: {
            name: '地址编辑',
            key: 'c09f7b19-a13e-40c2-9f98-a5bf4e1202ad'
        },
        appDetail: {
            name: '商品详情',
            key: '413b9a0d-01f9-4d83-881d-62f708045601'
        },
        home: {
            name: '首页',
            key: '0c578698-3b34-4445-a5f3-ef3de9bff403'
        },
        logisticsDetail: {
            name: '物流信息',
            key: '74a77b6b-82b4-444c-a6a1-2b9056c21cad'
        },
        my: {
            name: '我的',
            key: 'd7cf767f-e747-4f31-8641-8625d595f9ec'
        },
        order: {
            name: '订单列表',
            key: '79683b97-65cb-44f6-a887-1c3f72c17785'
        },
        orderDetails: {
            name: '订单详情',
            key: '66934f0c-b08b-4f64-91f0-a885f57d735f'
        },
        goBuy: {
            name: '确认订单',
            key: '82617ced-a6e0-4b73-b6c0-c284235584c4'
        },
        payOk: {
            name: '支付状态',
            key: 'dac0889c-8106-4977-98a1-c3ec43a336ea'
        },
        shop: {
            name: '购物车',
            key: '5a53aef2-7ef7-4245-b377-76c7c1a9c703'
        },
        addReturnOrder: {
            name: '申请退款',
            key: '8oolon2gfu0o6yeob0y2dsexdyy5zy2s1bt8'
        },
        evaluate: {
            name: '评价',
            key: 'h-0iyodj4tz3498liodnbadjequffvyoxgy2'
        }
    };

    private tingYunFun(name: string, key: string): void {
        // this.event = this.window.TINGYUN.createEvent({
        //     name: name,
        //     key: key
        // });
    }

    setTingYun(nameSpace: string): void {
        let name: any = this.routerObj[nameSpace].name;
        let key: any = this.routerObj[nameSpace].key;
        this.tingYunFun(name, key);
    }

    endTingYun() {
        // this.event.end();
    }
}

let tingYun: TingYun = new TingYun();

export default tingYun;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/tingYunBrowser.ts